import { Auth } from '@aws-amplify/auth';
import { useEffect } from 'react';

export const XeroAuth = () => {
  useEffect(() => {
    Auth.federatedSignIn({ customProvider: 'Xero' });
  }, []);
  return null;
};
